<template>
    <div class="timepicherplaceholder">
        <div class="hourminuteplaceholder hourPart">
            <label>Sat</label>
            <!-- :options="hours" -->
            <Dropdown v-model="selectedHour" :disabled="timePickerDisabled()" :options="computedHours" optionLabel="hourName" class="dropDownHours" @change="timechangedevent" />
        </div>
        <div class="hourminuteplaceholder minutePart">
            <label>Minut</label>
            <!-- :options="minutes" -->
            <Dropdown v-model="selectedMinute" :disabled="timePickerDisabled()" :options="computedMinutes" optionLabel="minuteName" class="dropDownMinutes" @change="timechangedevent" />
        </div>
        
    </div>
</template>

<script>

export default {
    emits: ['timeChanged'],
    props: {
        // timeStart: {
        //     type: String,
        //     required: false
        // },
        timeStartInt: {
            type: Number,
            required: false
        },
        homeVisitDate: {
            type: Date,
            required: false,
        }
    },
    computed: {
        hour() {
            let hours = [];
        },
        computedHours(){
            //debugger;
            if(this.homeVisitDate === null){
                this.hours = [];
                for (let i = 7; i < 21; i++) {
                    const numberString = i < 10 ? `0${i}` : `${i}`;
                    this.hours.push({hourName:numberString, hourValue:i });         
                }
            }
            else if(this.homeVisitDate.getDay() === 0){
                this.hours = [];
                for (let i = 7; i < 18; i++) {
                    const numberString = i < 10 ? `0${i}` : `${i}`;
                    this.hours.push({hourName:numberString, hourValue:i });         
                }
            }
            else if (this.homeVisitDate.getDay() === 6){
                this.hours = [];
                for (let i = 7; i < 19; i++) {
                    const numberString = i < 10 ? `0${i}` : `${i}`;
                    this.hours.push({hourName:numberString, hourValue:i });         
                }
            }
            else{
                this.hours = [];
                for (let i = 7; i < 21; i++) {
                    const numberString = i < 10 ? `0${i}` : `${i}`;
                    this.hours.push({hourName:numberString, hourValue:i });         
                }
            }
            // console.log(this.hours);
            return this.hours;
        },
        computedMinutes(){
            //debugger;
            // console.log(this.selectedHour);
            // console.log(this.selectedMinute);
            // console.log(this.hours);
            // console.log(this.minutes);
            if(this.selectedHour.hourValue === 7){
                this.minutes = [];
                this.minutes.push({minuteName:'30', minuteValue:30});
                //this.minutes.push({minuteName:'45', minuteValue:45});
            }
            else if (this.selectedHour.hourValue === this.hours[this.hours.length-1].hourValue){
                this.minutes = [];
                this.minutes.push({minuteName:'00', minuteValue:0});
            }
            else{
                this.minutes = [];
                this.minutes.push({minuteName:'00', minuteValue:0});
                //this.minutes.push({minuteName:'15', minuteValue:15});
                this.minutes.push({minuteName:'30', minuteValue:30});
                //this.minutes.push({minuteName:'45', minuteValue:45});
            }
            // console.log(this.minutes);
            // console.log(this.selectedMinute);
            return this.minutes;
        }
    },
    data() {
        return {  
            selectedHour: {},
            selectedMinute: {},
            hours: [],
            minutes: []
        }
    },
    watch: {
        timeStartInt: function(newVal) {
            // console.log('timeStartInt:'+newVal);
            this.setHourMinutesFromInt(newVal);
        }
    },
    mounted(){

        // for (let i = 7; i < 21; i++) {
        //     const numberString = i < 10 ? `0${i}` : `${i}`;
        //     this.hours.push({hourName:numberString, hourValue:i });         
        // }

        // this.minutes.push({minuteName:'00', minuteValue:0});
        // this.minutes.push({minuteName:'15', minuteValue:15});
        // this.minutes.push({minuteName:'30', minuteValue:30});
        // this.minutes.push({minuteName:'45', minuteValue:45});

        //debugger;
        if(this.timeStartInt != null){
            this.setHourMinutesFromInt(this.timeStartInt);

            // let hour = Math.floor(this.timeStartInt / 60);
            // let minute = this.timeStartInt % 60;    

            // this.selectedHour = this.hours.find((item) => item.hourValue === hour);
            // this.selectedMinute = this.minutes.find((item) => item.minuteValue === minute);
        } 
        // else 
        // {
        //     let hourminute = this.timeStart.split(':');

        //     if(hourminute.length>1) {
        //         this.selectedHour = this.hours[parseInt(hourminute[0])];
        //         this.selectedMinute = this.minutes.find((item) => item.minuteValue === parseInt(hourminute[1]));
        //     }
        //     else {
        //         this.selectedHour = this.hours[9];
        //         this.minutes = this.minutes[0];
        //     }         
        // }
     
    },
    methods: {
        timechangedevent() {

            if(this.selectedMinute.minuteValue == null) {
                this.selectedMinute = this.minutes[0];
            }

            if(this.selectedHour.hourValue == null) {
                this.selectedHour = this.hours[0];
            }

            // console.log('timechangedevent: ' + this.selectedHour.hourValue + ':' + this.selectedMinute.minuteValue);
            let timeInt = this.selectedHour.hourValue * 60 + this.selectedMinute.minuteValue;
            this.$emit('timeChanged', this.selectedHour.hourName + ':' + this.selectedMinute.minuteName, timeInt);
        },
        setHourMinutesFromInt(timeInt) {
            //debugger;
            let hour = Math.floor(timeInt / 60);
            let minute = timeInt % 60;
            this.selectedHour = this.hours.find((item) => item.hourValue === hour);
            if (this.selectedHour === undefined) {
                this.hours = this.recomputedHours();
                this.selectedHour = this.hours[this.hours.length-1];
            }

            if(minute == 45) {
                minute = 30;
            }

            this.selectedMinute = this.minutes.find((item) => item.minuteValue === minute);
            if(this.selectedMinute === undefined){
                this.minutes = this.recomputedMinutes();
                this.selectedMinute = this.minutes.find((item) => item.minuteValue === minute);
            }
        },
        timePickerDisabled(){
            //debugger;  
            // console.log(this.homeVisitDate);
            if(this.homeVisitDate == null){
                return true;
            }
            return false;
        },
        recomputedHours(){
            //debugger;
            if(this.homeVisitDate === null){
                this.hours = [];
                for (let i = 7; i < 21; i++) {
                    const numberString = i < 10 ? `0${i}` : `${i}`;
                    this.hours.push({hourName:numberString, hourValue:i });         
                }
            }
            else if(this.homeVisitDate.getDay() === 0){
                this.hours = [];
                for (let i = 7; i < 18; i++) {
                    const numberString = i < 10 ? `0${i}` : `${i}`;
                    this.hours.push({hourName:numberString, hourValue:i });         
                }
            }
            else if (this.homeVisitDate.getDay() === 6){
                this.hours = [];
                for (let i = 7; i < 19; i++) {
                    const numberString = i < 10 ? `0${i}` : `${i}`;
                    this.hours.push({hourName:numberString, hourValue:i });         
                }
            }
            else{
                this.hours = [];
                for (let i = 7; i < 21; i++) {
                    const numberString = i < 10 ? `0${i}` : `${i}`;
                    this.hours.push({hourName:numberString, hourValue:i });         
                }
            }
            // console.log(this.hours);
            return this.hours;
        },
        recomputedMinutes(){
            //debugger;
            // console.log(this.selectedHour);
            // console.log(this.selectedMinute);
            // console.log(this.hours);
            // console.log(this.minutes);
            if(this.selectedHour.hourValue === 7){
                this.minutes = [];
                this.minutes.push({minuteName:'30', minuteValue:30});
                //this.minutes.push({minuteName:'45', minuteValue:45});
            }
            else if (this.selectedHour.hourValue === this.hours[this.hours.length-1].hourValue){
                this.minutes = [];
                this.minutes.push({minuteName:'00', minuteValue:0});
            }
            else{
                this.minutes = [];
                this.minutes.push({minuteName:'00', minuteValue:0});
                //this.minutes.push({minuteName:'15', minuteValue:15});
                this.minutes.push({minuteName:'30', minuteValue:30});
                //this.minutes.push({minuteName:'45', minuteValue:45});
            }
            // console.log(this.minutes);
            // console.log(this.selectedMinute);
            return this.minutes;
        }
    }
}
</script>

<style scoped>
.timepicherplaceholder { position: relative; float: left; width: 100%; }
.timepicherplaceholder .hourminuteplaceholder { width: 48%; position: relative; }
.timepicherplaceholder .hourPart { margin-right: 3px; float: left; }
.timepicherplaceholder .minutePart { margin-left: 3px; float: right; }

.hourminuteplaceholder.hourPart label, .hourminuteplaceholder.minutePart label {
    position: relative;
    float: left;
    width: 100%;
    font-size: 0.75rem;
}

</style>